/**
 * Tif version number that is stored at the start of a tif file
 */
export var TiffVersion;
(function (TiffVersion) {
    /**
     * Big tif's,
     * generally uses 64bit numbers for offsets
     * @see http://bigtiff.org/
     **/
    TiffVersion[TiffVersion["BigTiff"] = 43] = "BigTiff";
    /**
     * Original tif
     * Uses 32 bit or smaller numbers for offsets and counters
     */
    TiffVersion[TiffVersion["Tiff"] = 42] = "Tiff";
})(TiffVersion || (TiffVersion = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlmZi52ZXJzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0L3RpZmYudmVyc2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFdBWVg7QUFaRCxXQUFZLFdBQVc7SUFDbkI7Ozs7UUFJSTtJQUNKLG9EQUFZLENBQUE7SUFDWjs7O09BR0c7SUFDSCw4Q0FBUyxDQUFBO0FBQ2IsQ0FBQyxFQVpXLFdBQVcsS0FBWCxXQUFXLFFBWXRCIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUaWYgdmVyc2lvbiBudW1iZXIgdGhhdCBpcyBzdG9yZWQgYXQgdGhlIHN0YXJ0IG9mIGEgdGlmIGZpbGVcbiAqL1xuZXhwb3J0IGVudW0gVGlmZlZlcnNpb24ge1xuICAgIC8qKlxuICAgICAqIEJpZyB0aWYncyxcbiAgICAgKiBnZW5lcmFsbHkgdXNlcyA2NGJpdCBudW1iZXJzIGZvciBvZmZzZXRzXG4gICAgICogQHNlZSBodHRwOi8vYmlndGlmZi5vcmcvXG4gICAgICoqL1xuICAgIEJpZ1RpZmYgPSA0MyxcbiAgICAvKipcbiAgICAgKiBPcmlnaW5hbCB0aWZcbiAgICAgKiBVc2VzIDMyIGJpdCBvciBzbWFsbGVyIG51bWJlcnMgZm9yIG9mZnNldHMgYW5kIGNvdW50ZXJzXG4gICAgICovXG4gICAgVGlmZiA9IDQyLFxufVxuIl19